export default {"src":"/_next/static/media/trash.ad9e36ce.svg","height":20,"width":20};